/* RESPONSIBLE TEAM: team-proactive-support */
import NodeConfiguration, { NODE_CATEGORIES } from 'embercom/objects/series/node-configuration';
import PushInserterConfiguration from 'embercom/objects/series/node/push-inserter-configuration';

export default class PushNodeConfiguration extends NodeConfiguration {
  inserterConfiguration = new PushInserterConfiguration();
  category = NODE_CATEGORIES.content;
}
